import React from 'react';
import styled from 'styled-components';
import gallery from 'src/data/gallery';

import media from 'src/styles/media';

const FullImage = props => {
  return (
    <Wrapper>
      {gallery.map((item, index) => {
        return (
          <Image
            key={index}
            style={{
              backgroundImage: `url(/assets/images/gallery/${item.id}.png)`,
            }}
            active={props.active === item.id}
          />
        );
      })}
      {gallery.map((item, index) => {
        return (
          <Caption
            key={index}
            className={props.active === item.id ? 'active' : ''}
          >
            {item.caption}
          </Caption>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 71.5%;
  /* height: 71.5%; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
  pointer-events: none;
  &::after {
    content: '';
    width: 100%;
    padding-top: 100%;
    display: block;
  }
`;

const Image = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%) translateZ(0px);
  transition: all 0.75s;
  background-position: 50% 50%;
  background-size: cover;
  opacity: ${props => (props.active ? '1' : '0')};
  transform: translate(-50%, -50%)
    ${props => (props.active ? 'scale(1)' : 'scale(1.2)')};
`;

const Caption = styled.h1`
  color: ${props => props.theme.colorPrimary};
  color: #fff;
  position: absolute;
  width: 55%;
  bottom: 11%;
  left: 50%;
  transform: translateX(-50%) translateY(20px) translateZ(0px);
  opacity: 0;
  font-size: 24px;
  font-family: ${({ theme }) => theme.fontHeader};
  text-transform: uppercase;
  transition: all 0.5s;
  @media (max-width: ${media.sm}) {
    font-size: 18px;
  }
  @media (max-width: ${media.xs}) {
    font-size: 12px;
  }
  &.active {
    opacity: 1;
    transform: translateX(-50%) translateY(0%);
  }
`;

export default FullImage;



// WEBPACK FOOTER //
// ./src/components/Gallery/elements/FullImage.js